import { Button, Icon, HStack, VStack } from "../../primitives";
import { useTranslation } from "react-i18next";

export interface WorkflowCardDropdownProps {
	workflows: { id: string; name: string }[];
	selectedId?: string;
	onSelect: (id: string) => void;
	onDelete: (id: string) => void;
	onNewWorkflow: () => void;
}

export const WorkflowCardDropdown = (p: WorkflowCardDropdownProps) => {
	const { t } = useTranslation();

	return (
		<VStack
			data-dropdown
			className="max-h-[480px] overflow-y-auto justify-start bg-bg-weak/95 gap-[20px] p-[16px] rounded-[20px] w-full absolute left-0 top-full mt-[10px] z-20 border-outline backdrop-blur-md shadow-[0_12px_40px_rgba(15,23,42,0.1)]"
			initial={{ opacity: 0, y: -8 }}
			animate={{ opacity: 1, y: 0 }}
			exit={{ opacity: 0, y: -8 }}
			transition={{ duration: 0.4, ease: "easeOut" }}
		>
			<VStack className="w-full gap-[10px]">
				{p.workflows.map((workflow) => (
					<HStack key={workflow.id} className="w-full justify-between px-[6px] py-[10px] text-md font-medium text-ct-strong">
						<button className="w-full" onClick={() => p.onSelect(workflow.id)}>
							<span className="w-full text-left">{workflow.name}</span>
						</button>
						<button
							className="p-[6px] rounded-[6px] bg-bg-regular text-ct-regular shrink-0"
							onClick={(e) => {
								e.stopPropagation();
								p.onDelete(workflow.id);
							}}
						>
							<Icon name="Trash" width={18} height={18} />
						</button>
					</HStack>
				))}
			</VStack>
			<Button className="w-full" onClick={p.onNewWorkflow} variant="primary" size="lg">{t("sitemap.workflow-new")}</Button>
		</VStack>
	);
}
